<template>
  <div>
    <div v-if="mode==='LIST'">
      <h3 class="page-title my-4"><mdb-icon  icon="chalkboard-teacher" /> 강사 관리</h3>
      <div class="text-right indigo-text bolder">
        <div class="clearfix">
          <div class="float-left"><mdb-icon icon="search"/> 검색: <input type="text" class="input-underline" v-model="keyword"/></div>
          <div class="float-right">
            [{{teacherList.length}} 명]
            <mdb-btn icon="user-plus" class="m-0 p-1" @click="onEditUser({})"/>
            </div>
        </div>
      </div>
      <teacher-list :teachers="filteredStaffs"
          :startIndex="startIndex"
          @edit-user="onEditUser" @delete-user="onDeleteUser"/>
      <pagination :pageInfo="pageInfo" @change-page="onChangePage"/>
    </div>
    <div v-if="mode==='VIEW'">
      <h3 class="page-title"><mdb-icon  icon="chalkboard-teacher" /> 강사 정보</h3>
      <teacher :teacher="teacher"  @change-mode="onChangeMode"/>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Teacher from '../../components/member/Teacher.vue';
import TeacherList from '../../components/member/TeacherList.vue';
import Pagination from '../common/Pagination.vue';

export default {
  name: 'TeacherManage',
  components: { TeacherList, Teacher, Pagination },
  props: [],
  data: () => ({
    teachers: [],
    teacher: {},
    page: 1,
    mode: 'LIST',
    pageInfo: {},
    keyword: ''
  }),
  computed: {
    ...mapState('auth', ['org']),
    teacherList () {
      return this.teachers
        .filter(t => !this.keyword || t.name.indexOf(this.keyword) !== -1)
    },
    filteredStaffs () {
      return this.teacherList
        .slice(this.startIndex, this.startIndex + 10)
    },
    startIndex () {
      return (this.page - 1) * 10
    }
  },
  methods: {
    onChangeMode (mode, userId) {
      this.mode = mode;
      if (mode === 'VIEW') {
        this.teacher = this.teachers.find(s => s.userId === userId)
      }
    },
    onChangePage (page) {
      this.page = page
      this.pageInfo.page = page
    },
    async onEditUser (user) {
      this.$router.push({ name: 'StaffTeacherEdit', query: { teacher: user._id } })
    },
    async onDeleteUser (user) {
      if (!confirm('삭제할까요?')) return
      try {
        await user.delete()
        await this.load()
      } catch (e) {
        console.log(e)
      }
    },
    makePageInfo () {
      return {
        totalPage: this.teachers.length
      }
    },
    async load () {
      if (this.org._id) {
        this.teachers = await this.$member.teacherList(this.org._id)
        this.pageInfo = this.$pageInfo(this.teachers)
      }
    }
  },
  async created () { this.load() },
  watch: {
    org () { this.load() },
    keyword () {
      this.pageInfo = this.$pageInfo(this.teacherList)
      this.onChangePage(1)
    }
  }
}
</script>
